import { render, staticRenderFns } from "./AdminsAndNotifications.vue?vue&type=template&id=7498f180&scoped=true&"
import script from "./AdminsAndNotifications.vue?vue&type=script&lang=js&"
export * from "./AdminsAndNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AdminsAndNotifications.vue?vue&type=style&index=0&id=7498f180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7498f180",
  null
  
)

export default component.exports